export default "/images/vendor/flag-icons/flags/4x3/cz.svg?5a24757d105fbe7a4e81f64549ec8d2e";